import { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "@/shared/ui";
import { FactionEnum } from "@/domains/faction/constants/factionEnum";
import FactionBlockLayout from "@/domains/faction/components/FactionBlockLayout";
import FactionTextBlock from "@/domains/faction/components/FactionTextBlock";

type Props = {
  count: number;
  i18key: string;
  faction: FactionEnum;
  onClick: () => void;
  Icon?: ComponentType<{ className?: string }>;
  isSoon?: boolean;
};

export default function FactionStatusCard({
  count,
  i18key,
  faction,
  onClick,
  Icon,
  isSoon,
}: Props) {
  const { t } = useTranslation("faction");

  return (
    <div
      className="relative p-4 bg-dark-800 rounded-2xl bg-cover bg-no-repeat"
      style={{ backgroundImage: `url(./svg/faction/${faction}_block.svg)` }}
    >
      {isSoon && <FactionBlockLayout text={`${t("faction.soon")}...`} />}
      <div className="flex items-center mb-3">
        {Icon ? <Icon className="mr-2 size-4.5" /> : null}
        <p className="text-14 font-bold uppercase leading-none">{t(`faction.${i18key}.title`)}</p>
        <FactionTextBlock
          text="Активно:"
          text2={count}
          className="h-auto ml-auto py-2 px-3 bg-[#212121] rounded-[0.3125rem]"
          classNameText1="text-[0.75rem] text-white/70"
          classNameText2="text-[0.75rem] text-white"
        />
      </div>
      <p className="mb-3.5 text-14 font-medium text-white/70">
        {t(`faction.${i18key}.description`)}
      </p>
      <Button
        variant={count ? "solid-gradient" : "solid"}
        className={clsx("w-full h-12", !count && "bg-white/3 pointer-events-none")}
        onClick={onClick}
      >
        {t("faction.goToImprovements")}
      </Button>
    </div>
  );
}
